
document.addEventListener("DOMContentLoaded", function() {

	var $ = jQuery.noConflict(),
		swiper,
		testimonials,
		technical,
		sectors;

	// Default Row Slider section
	$('.wp-block-tfa-row-section.slider-section > .row').addClass('swiper-wrapper');
	$('.wp-block-tfa-row-section.slider-section > .row > .wp-block-tfa-column').addClass('swiper-slide');
	$('.wp-block-tfa-row-section.slider-section').append('<div class="swiper-slider-section-nav"><div class="swiper-button-prev"></div><div class="swiper-pagination"></div><div class="swiper-button-next"></div></div>');
	setTimeout(function() {
		swiper = new Swiper('.wp-block-tfa-row-section.slider-section', {
			observeSlideChildren: true,
			slideToClickedSlide: true,
			updateOnWindowResize: true,
			slidesPerView: 1,
			spaceBetween: 0,
			loop: false,
			breakpoints: {
				320: {
					slidesPerView: 1
				},
				760: {
					slidesPerView: 1
				},
				992: {
					slidesPerView: 3
				}
			},
			autoplay: {
				disableOnInteraction: false,
    			pauseOnMouseEnter: true,
			},
			keyboard: {
				enabled: true,
				onlyInViewport: false,
			},
			pagination: {
				el: '.swiper-slider-section-nav .swiper-pagination',
				clickable: true,
			},
			navigation: {
				nextEl: '.swiper-slider-section-nav .swiper-button-next',
				prevEl: '.swiper-slider-section-nav .swiper-button-prev',
			},
			grabCursor: true
		});
	}, 500);

	// Run Swiper slider for section only Tablet Up
	//$('.section__special-services .swiper-slider-section-nav').remove();
	$('.section__special-services .row.one-column-layout > .wp-block-tfa-column > .wp-block-tfa-row-section').append('<div class="swiper-slider-section-nav"><div class="swiper-button-prev"></div><div class="swiper-pagination"></div><div class="swiper-button-next"></div></div>');

	var specServicesSlider = function() {

		if (window.innerWidth >= 768) {			
			$('.section__special-services .row.one-column-layout > .wp-block-tfa-column > .wp-block-tfa-row-section').addClass('slider-section');
			$('.section__special-services .row.one-column-layout > .wp-block-tfa-column > .wp-block-tfa-row-section > .row').addClass('swiper-wrapper');
			$('.section__special-services .row.one-column-layout > .wp-block-tfa-column > .wp-block-tfa-row-section > .row > .wp-block-tfa-column').addClass('swiper-slide');
			$('.section__special-services .swiper-slider-section-nav').show();

			setTimeout(function() {

				var swiperSpecServ = new Swiper('.section__special-services .row.one-column-layout > .wp-block-tfa-column > .row', {
					slideToClickedSlide: true,
					spaceBetween: 0,
					loop: false,
					breakpoints: {
						768: {
							slidesPerView: 2
						},
						992: {
							slidesPerView: 3
						}
					},
					autoplay: {
						disableOnInteraction: false,
    					pauseOnMouseEnter: true,
					},
					keyboard: {
						enabled: true,
						onlyInViewport: false,
					},
					pagination: {
						el: '.swiper-slider-section-nav .swiper-pagination',
						clickable: true,
					},
					navigation: {
						nextEl: '.swiper-slider-section-nav .swiper-button-next',
						prevEl: '.swiper-slider-section-nav .swiper-button-prev',
					},
					grabCursor: true
				});

			}, 500);

		} else {
			$('.section__special-services .row.one-column-layout > .wp-block-tfa-column > .wp-block-tfa-row-section > .row').removeClass('swiper-wrapper');
			$('.section__special-services .row.one-column-layout > .wp-block-tfa-column > .wp-block-tfa-row-section > .row > .wp-block-tfa-column').removeClass('swiper-slide');
			$('.section__special-services .swiper-slider-section-nav').hide();
		}
	}
	specServicesSlider();

	window.addEventListener('resize', function(event) {
		specServicesSlider();
	}, true);

	// Related pages & posts
	swiper = new Swiper('.related-pages.swiper-slider, .related-posts.swiper-slider', {
		observeSlideChildren: true,
		slideToClickedSlide: true,
		updateOnWindowResize: true,
		slidesPerView: 3,
		spaceBetween: 30,
		loop: true,
		breakpoints: {
			320: {
				slidesPerView: 1
			},
			760: {
				slidesPerView: 2
			},
			992: {
				slidesPerView: 3
			}
		},
		autoplay: {
			disableOnInteraction: false,
    		pauseOnMouseEnter: true,
		},
		keyboard: {
			enabled: true,
			onlyInViewport: false,
		},
		pagination: {
			el: '.swiper-slider-related-nav .swiper-pagination',
			clickable: true,
		},
		navigation: {
			nextEl: '.swiper-slider-related-nav .swiper-button-next',
			prevEl: '.swiper-slider-related-nav .swiper-button-prev',
		},
		grabCursor: true
	});

	testimonials = new Swiper('.testimonials-slider', {
		observeSlideChildren: true,
		slideToClickedSlide: true,
		updateOnWindowResize: true,
		slidesPerView: 4,
		spaceBetween: 30,
		autoHeight: true,
		loop: true,
		breakpoints: {
			320: {
				slidesPerView: 1
			},
			760: {
				slidesPerView: 2
			},
			992: {
				slidesPerView: 4
			}
		},
		autoplay: {
			disableOnInteraction: false,
    		pauseOnMouseEnter: true,
		},
		keyboard: {
			enabled: true,
			onlyInViewport: false,
		},
		pagination: {
			el: '.testimonials-slider--nav .swiper-pagination',
			clickable: true,
		},
		navigation: {
			nextEl: '.testimonials-slider--nav .swiper-button-next',
			prevEl: '.testimonials-slider--nav .swiper-button-prev',
		},
		grabCursor: true
	});

	technical = new Swiper('.technicals-slider', {
		observeSlideChildren: false,
		slideToClickedSlide: true,
		updateOnWindowResize: true,
		slidesPerView: 1,
		spaceBetween: 30,
		autoHeight: true,
		loop: true,
		breakpoints: {
			320: {
				slidesPerView: 1
			},
			760: {
				slidesPerView: 1.3
			},
			992: {
				slidesPerView: 2.3
			}
		},
		autoplay: {
			disableOnInteraction: false,
    		pauseOnMouseEnter: true,
		},
		keyboard: {
			enabled: true,
			onlyInViewport: false,
		},
		navigation: {
			nextEl: '.swiper-button-next',
			prevEl: '.swiper-button-prev',
		},
		pagination: {
			el: '.swiper-pagination',
			clickable: true,
		  },
		grabCursor: true
	});

	sectors = new Swiper('.sectors-slider', {
		observeSlideChildren: false,
		slideToClickedSlide: true,
		updateOnWindowResize: true,
		slidesPerView: 1,
		spaceBetween: 30,
		autoHeight: true,
		loop: true,
		breakpoints: {
			320: {
				slidesPerView: 1
			},
			760: {
				slidesPerView: 1.3
			},
			992: {
				slidesPerView: 2.3
			}
		},
		autoplay: {
			disableOnInteraction: false,
    		pauseOnMouseEnter: true,
		},
		keyboard: {
			enabled: true,
			onlyInViewport: false,
		},
		navigation: {
			nextEl: '.swiper-button-next',
			prevEl: '.swiper-button-prev',
		},
		grabCursor: true
	});
});